import { find, map } from 'lodash'
import { useIntl } from 'react-intl'
import { useQuery } from 'react-query'

import { getOrganization } from '@/components/App/selectors'
import Modal from '@/components/Modal'
import { Role } from '@/components/RolesContainer'
import Button from '@/components/TailwindUI/Button'
import { useAppSelector } from '@/store/hooks'

import messages from './messages'

type PermissionsModalProps = {
  isOpen: boolean
  onClose: () => void
  requiredRoles?: Role[]
}
const AdditionalPermissionsModal = ({ isOpen, onClose, requiredRoles }: PermissionsModalProps) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xs">
      <AdditionalPermissionsModalContent onClose={onClose} requiredRoles={requiredRoles} />
    </Modal>
  )
}

export default AdditionalPermissionsModal

export const AdditionalPermissionsModalContent = ({
  requiredRoles,
  onClose
}: {
  requiredRoles?: Role[]
  onClose: () => void
}) => {
  const organization = useAppSelector(getOrganization)
  const intl = useIntl()

  const fetchRoles = useQuery<{ data: any; status: string }>({
    queryKey: ['/v1/admin/roles', organization],
    enabled: !!requiredRoles
  })

  const getDisplayName = (role: Role) => {
    return find(fetchRoles.data?.data, item => item.name === role)?.displayName || ''
  }
  return (
    <div className="px-6">
      <div className="mt-3 text-center">
        <h3 className="text-base font-semibold leading-6 text-zinc-900">{intl.formatMessage(messages.heading)}</h3>
        <div className="mt-2">
          <p className="text-sm text-zinc-500">
            {intl.formatMessage(messages.paragraph1)}
            {organization?.supportUrl ? (
              <>
                &nbsp;(
                <a
                  href={(organization.supportUrl.includes('@') ? 'mailto:' : '') + organization.supportUrl}
                  className="text-sm font-normal text-brand-400 hover:underline"
                >
                  {organization.supportUrl}
                </a>
                )&nbsp;
              </>
            ) : (
              ' '
            )}
            {intl.formatMessage(messages.paragraph2)}
          </p>
        </div>
      </div>
      {requiredRoles && (
        <div className="mt-3 text-center text-sm font-semibold">
          {intl.formatMessage(messages.requiredRoles, {
            roles: map(requiredRoles, role => {
              return getDisplayName(role)
            }).join(', or ')
          })}
        </div>
      )}

      <div className="mt-5 w-full text-right">
        <Button color="primary" onClick={() => onClose()}>
          {intl.formatMessage(messages.dismiss)}
        </Button>
      </div>
    </div>
  )
}
